export const SPOTLIGHT = 'SPOTLIGHT';
export const MIXES = 'MIXES';
export const LINKS = 'LINKS';
export const COLORS = 'COLORS';
